import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export type LeadsFunnelStatus = {
  hasActiveConfig: boolean;
  schemaVersion: number | null;
  compatible: boolean;
  hasLeadsAgent: boolean;
  requiresMigration: boolean;
};

type LeadsFunnelLegacyBannerProps = {
  status: LeadsFunnelStatus | null;
};

export function LeadsFunnelLegacyBanner({ status }: LeadsFunnelLegacyBannerProps) {
  if (!status?.requiresMigration) {
    return null;
  }

  const versionLabel =
    status.schemaVersion === null ? 'desconocida' : `v${status.schemaVersion}`;

  return (
    <Alert variant='destructive' className='rounded-2xl border-amber-500/40 bg-amber-50 text-amber-950 dark:bg-amber-950/30 dark:text-amber-50'>
      <AlertTriangle className='h-4 w-4' />
      <AlertTitle>Embudo comercial obsoleto ({versionLabel})</AlertTitle>
      <AlertDescription className='space-y-3'>
        <p>
          Este tenant tiene una configuración de embudo anterior al contrato actual (formato v2).
          El tablero y el motor de leads usan la plantilla nueva; hasta migrar, las oportunidades pueden
          mostrarse sin etiquetas de vertical.
        </p>
        {status.hasLeadsAgent ? (
          <p className='text-sm'>
            Hay un agente de leads activo: aplicá la plantilla v2 desde Configuración para evitar
            inconsistencias en producción.
          </p>
        ) : (
          <p className='text-sm'>
            No hay agente de embudo en este tenant. Podés aplicar la plantilla v2 cuando quieras
            habilitar leads comerciales aquí.
          </p>
        )}
        <Button variant='outline' size='sm' asChild className='border-amber-600/30 bg-white/80'>
          <Link to='/admin/leads/funnel-config'>Ir a configuración del embudo</Link>
        </Button>
      </AlertDescription>
    </Alert>
  );
}
